/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Checks_TitleInputs */

const en_rd_checks_title = /** @type {(inputs: Rd_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What an agent finds`)
};

const id_rd_checks_title = /** @type {(inputs: Rd_Checks_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang ditemukan agent`)
};

/**
* | output |
* | --- |
* | "What an agent finds" |
*
* @param {Rd_Checks_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_checks_title = /** @type {((inputs?: Rd_Checks_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Checks_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_checks_title(inputs)
	return en_rd_checks_title(inputs)
});